import { useEffect, useState } from "react";
import { api, errorMessage } from "../lib/api";

const STATS = [["assigned", "Assegnati"], ["worked", "Lavorati"], ["worked_pct", "% lavorati"],
  ["untouched", "Non toccati"], ["stalled", "Fermi"], ["calls", "Chiamate"],
  ["successful_contacts", "Contatti"], ["appointments", "Appuntamenti"],
  ["meetings_done", "Incontri fatti"], ["clients", "Clienti"], ["conversion_pct", "% a cliente"],
  ["monthly_value_cents", "Valore mensile"], ["missing_outcomes", "Esiti mancanti"],
  ["days_since_activity", "Giorni inattivi"]];

export const PersonStats = ({ row, people, session, onBack, onEdit, onChanged }) => {
  const [list, setList] = useState(null);
  const [items, setItems] = useState([]);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const open = async (view) => {
    setList(view); setError("");
    try { const { data } = await api.get(`/team/stats/${row.id}/venues`, { params: { view } });
      setItems(data.items); }
    catch (e) { setError(errorMessage(e)); }
  };
  useEffect(() => { setList(null); setItems([]); }, [row.id]);
  const reassign = async (venueId, salespersonId) => {
    if (!salespersonId) return;
    setBusy(true); setError("");
    try { await api.patch(`/venues/${venueId}/reassign`, { salesperson_id: salespersonId },
      { headers: { "X-CSRF-Token": session.csrf_token } });
      setItems((current) => current.filter((venue) => venue.id !== venueId)); onChanged(); }
    catch (e) { setError(errorMessage(e)); }
    finally { setBusy(false); }
  };
  return <div className="person-stats" data-testid="person-stats">
    <button type="button" className="sheet-back" onClick={list ? () => setList(null) : onBack}
      data-testid="person-stats-back">‹ {list ? row.name : "Squadra"}</button>
    <h2 className="sheet-title" data-testid="person-stats-name">{row.name}</h2>
    {!list ? <><div className="person-stats-grid">{STATS.map(([key, label]) =>
      <div key={key} className={(key === "untouched" && row.untouched_overdue > 0)
        || (key === "stalled" && row.stalled > 0) || (key === "missing_outcomes" && row.missing_outcomes > 0)
        || (key === "days_since_activity" && row.days_since_activity >= 2) ? "stat-danger" : ""}
        data-testid={`person-stat-${key}`}><small>{label}</small><strong>{key === "monthly_value_cents"
        ? `${((row[key] || 0) / 100).toLocaleString("it-IT", { minimumFractionDigits: 2 })} €`
        : key.endsWith("_pct") ? `${row[key]}%` : row[key] ?? "—"}</strong></div>)}</div>
      <div className="person-stats-actions"><button type="button" className="hud-button hud-secondary" onClick={() => open("untouched")}
        data-testid="person-untouched-button">Non toccati · {row.untouched}</button>
        <button type="button" className="hud-button hud-secondary" onClick={() => open("stalled")}
          data-testid="person-stalled-button">Fermi · {row.stalled}</button>
        <button type="button" className="text-action" onClick={onEdit} data-testid="person-edit-button">Modifica persona ›</button></div></>
      : <><h3 className="section-label">{list === "untouched" ? "NON TOCCATI" : "FERMI"}</h3>
        {!items.length && <p className="venue-no-meetings" data-testid="person-list-empty">Nessun locale.</p>}
        {items.map((venue) => <div className="person-venue-row" key={venue.id} data-testid={`person-venue-${venue.id}`}>
          <strong>{venue.name}</strong><small>{venue.status}</small>
          <select aria-label={`Riassegna ${venue.name}`} value="" disabled={busy}
            onChange={(e) => reassign(venue.id, e.target.value)} data-testid={`person-reassign-${venue.id}`}>
            <option value="">Riassegna ›</option>{people.filter((person) => person.active && person.role === "commerciale"
              && person.id !== row.id).map((person) => <option key={person.id} value={person.id}>{person.name}</option>)}</select>
        </div>)}</>}
    {error && <p role="alert" className="form-error" data-testid="person-stats-error">{error}</p>}
  </div>;
};